import React, { useEffect } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Container,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  FormText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// import NotificationSystem from "react-notification-system";

import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { commonService } from "../../_services";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";

import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import SelectListComponent from "../utils/selectList";
import OverviewCard from "./over-view";
import { appHelpers, store } from "../../_helpers";
import moment from "moment";
import BarChart from "./bar-chart";
import PieChart from "./pie-chart";
import AreaChart from "./area-chart";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

const presentDate = new Date();

class AvicollectDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentError: false, //Errors that affect content on the page
      componentErrorMessages: [], //Errors generated within the component form
      componentError: false, //Errors generated within the component
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      openTab: 1,
      dropdownOpen: false,
      selectedValue: "",
      startDate: new Date(),
      endDate: moment(presentDate, "YYYY-MM-DD"), //End date by default will always be current date
      islocal: false,
      totalFlights: 0,
      totalPassengers: 0,
      gmvNaira: 0,
      gmvDollar: 0,
      dashBoardReport: [],
      overviewSpiner: true,
      // pieChartSpinner: true,
      pieChatData: [],
      areaChartData: [],
      topCarrier: [],
      topDestination: [],
      topOrigin: [],
      areaChartSpinner: true,
      startDateWeek: "",
      endDateWeek: "",
      startDateLastMonth: "",
      endDateLastMonth: "",
      startDateThisYear: "",
      endDateThisYear: "",
    

      // Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
        
      },
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    // this._notificationSystem = this.refs.notificationSystem;
    const {islocal, startDateWeek, endDateWeek} = this.state;
    const today = new Date();
    const currentDayOfWeek = today.getDay();
    const diffToMonday = (currentDayOfWeek + 6) % 7;

    const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - diffToMonday);
    const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 6);

    let payload = {
      startDate:moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      islocal,
    };
    this.getDashboardReport(payload);
    this.calculateCurrentYearRange();
    this.calculateLastMonthRange();
    this.calculateWeekRange();
    // this.calculateLastYearRange();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.dashboard) {
      let newValues = newProps.dashboard.picker;
      let oldValues = this.props.dashboard.picker;

      let isSame = Object.is(newValues, oldValues);

      if (!isSame) {
        this.setState({
          overviewSpiner: true,
          pieChartSpinner: true,
          areaChartSpinner: true,
        });
        this.getDashboardReport(newValues);
      }
    }
  }

  calculateWeekRange() {
    const today = new Date();
    const currentDayOfWeek = today.getDay();
    const diffToMonday = (currentDayOfWeek + 6) % 7;

    const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - diffToMonday);
    const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 6);

    this.setState({
        startDateWeek: moment(startDate).format('YYYY-MM-DD'),
        endDateWeek: moment(endDate).format('YYYY-MM-DD')
    });
  }

  calculateLastMonthRange() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);

    this.setState({
        startDateLastMonth: moment(startDate).format('YYYY-MM-DD'),
        endDateLastMonth: moment(endDate).format('YYYY-MM-DD')
    });
  }

  calculateCurrentYearRange() {
    const today = new Date();
    const year = today.getFullYear();

    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31);

    this.setState({
        startDateThisYear: moment(startDate).format('YYYY-MM-DD'),
        endDateThisYear: moment(endDate).format('YYYY-MM-DD')
    });
  }


  
  toggleDropdown() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  handleSelect(value) {
    this.setState({ selectedValue: value });
  }

  // handleTabClick = (caseValue) => {
  //   const { startDate, endDate } = this.state;
  //   let payload;

  //   switch (caseValue) {
  //     case 0:
  //       payload = {
  //         startDate:moment(startDate).format('YYYY-MM-DD'),
  //         endDate: moment(endDate).format('YYYY-MM-DD'),
  //         islocal: false,
  //       };
  //       break;
  //     case 1:
  //       payload = {
  //         startDate:moment(startDate).format('YYYY-MM-DD'),
  //         endDate: moment(endDate).format('YYYY-MM-DD'),
  //         islocal: true,
  //       };
  //       break;
  //     default:
  //       break;
  //   }

  //   this.getDashboardReport(payload);
  // };
 
  // handlefilterClick = (caseValue) => {
  //   const {
  //     startDateWeek,
  //     endDateWeek,
  //     startDateLastMonth,
  //     endDateLastMonth,
  //     startDateThisYear,
  //     endDateThisYear,
  //     islocal,
  //   } = this.state;
  // console.log(islocal, "local");
  // console.log(startDateWeek, "week");

  //   let payload;
  //   let selectedValue;
  
  //   switch (caseValue) {
  //     case 0:
  //       payload = {
  //         startDate: startDateWeek,
  //         endDate: endDateWeek,
  //         islocal,
  //       };
  //       selectedValue = 'This Week';
  //       break;
  //     case 1:
  //       payload = {
  //         startDate: moment().startOf('month').format('YYYY-MM-DD'),
  //         endDate: moment().format('YYYY-MM-DD'),
  //         islocal,
  //       };
  //       selectedValue = 'This Month';
  //       break;
  //     case 2:
  //       payload = {
  //         startDate: startDateLastMonth,
  //         endDate: endDateLastMonth,
  //         islocal,
  //       };
  //       selectedValue = 'Last Month';
  //       break;
  //     case 3:
  //       payload = {
  //         startDate: startDateThisYear,
  //         endDate: endDateThisYear,
  //         islocal,
  //       };
  //       selectedValue = 'This Year';
  //       break;
  //     default:
  //       break;
  //   }
  
  //   this.setState({ selectedValue }, () => {
  //     this.getDashboardReport(payload);
  //   });
  // };
  
  handleTabClick = (caseValue) => {
    const { islocal } = this.state;
    const today = new Date();
    const currentDayOfWeek = today.getDay();
    const diffToMonday = (currentDayOfWeek + 6) % 7;

    const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - diffToMonday);
    const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 6);
    let payload;
  
    switch (caseValue) {
      case 0:
        payload = {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          islocal: false,
        };
        break;
      case 1:
        payload = {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          islocal: true,
        };
        break;
      default:
        break;
    }
  
    this.setState({ islocal,
      selectedValue: "",
    }, () => {
      this.getDashboardReport(payload);
    });
  };
  
  handlefilterClick = (caseValue) => {
    const {
      startDateWeek,
      endDateWeek,
      startDateLastMonth,
      endDateLastMonth,
      startDateThisYear,
      endDateThisYear,
      islocal,
      openTab,
    } = this.state;
  
    let payload;
    let selectedValue;
  
    switch (caseValue) {
      case 0:
        payload = {
          startDate: startDateWeek,
          endDate: endDateWeek,
          islocal: openTab === 1 ? false : true,
        };
        selectedValue = 'This Week';
        break;
      case 1:
        payload = {
          startDate: moment().startOf('month').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          islocal: openTab === 1 ? false : true,
        };
        selectedValue = 'This Month';
        break;
      case 2:
        payload = {
          startDate: startDateLastMonth,
          endDate: endDateLastMonth,
          islocal: openTab === 1 ? false : true,
        };
        selectedValue = 'Last Month';
        break;
      case 3:
        payload = {
          startDate: startDateThisYear,
          endDate: endDateThisYear,
          islocal: openTab === 1 ? false : true,
        };
        selectedValue = 'This Year';
        break;
      default:
        break;
    }
  
    this.setState({ selectedValue }, () => {
      this.getDashboardReport(payload);
    });
  };
  

  //   notify = (message, level) => {
  //     let notification = this.state.notification;
  //     notification["message"] = message;
  //     notification["level"] = level;
  //     notification.onRemove = this.onRemove;
  //     this._lastNotificationAdded = this._notificationSystem.addNotification(
  //       notification
  //     );
  //   };

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  getDashboardReport = (payload) => {
    const { dispatch } = this.props;
    const { startDate, endDate, islocal } = this.state;
   

    this.setState({ contentError: false });
    dispatch(apiActions.startRequest());

    commonService.getDashboardRecord(payload).then((res) => {
      dispatch(apiActions.endRequest());
      let response = res.response;

      if (res && res.status === appConstants.SUCCESS_RESPONSE) {
        // if (response.data != undefined && response.data.length > 0
        //     ) {
        this.setState(
          {
            totalFlights: response.data ? response.data.Result.Summary.TotalFlights : null,
            totalPassengers: response.data ? response.data.Result.Summary.TotalPassengers: null,
            gmvNaira: response.data ? response.data.Result.Summary.GmvNaira : null,
            gmvDollar: response.data ? response.data.Result.Summary.GmvDollar : null,
            pieChatData: response.data ? response.data.Result.TopAirlineRevenue : null,
            areaChartData: response.data ? response.data.Result.TopAirlineMostFlight : null,
            topCarrier: response.data ? response.data.Result.TopCarrier : null,
            topDestination:  response.data ? response.data.Result.TopDestination : null,
            topOrigin:  response.data ? response.data.Result.TopOrigin : null,
          }, 
          () => {
            this.setState({
              overviewSpiner: false,
            //   pieChartSpinner: false,
            //   areaChartSpinner: false,
            });
          }
        );
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        if (response === "Please Check your internet connectivity") {
          dispatch(alertActions.error(response));
        }
      }
    });
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }


  render() {
    let modalResponse = this.renderPageResponse();
    const { requesting, dashboard } = this.props;
    const { pageRequesting } = this.props;

    const {
      contentError,
      openTab,
      dropdownOpen,
      selectedValue,
      totalFlights,
      totalPassengers,
      gmvDollar,
      gmvNaira,
      overviewSpiner,
      pieChatData,
      areaChartData,
      topCarrier,
      topDestination,
      topOrigin,
    } = this.state;
console.log(selectedValue, "why");
    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            <CardBody>
              <div className="firstLayer">
                <ul className="tabDesign" role="tablist">
                  <li className="listDesign">
                    <a
                      className={"alist " + (openTab === 1 ? "aTab" : "aDif")}

                      // className={"alist" + (openTab === 1 ? "aTab" : "aDif")}
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleTabClick(0);
                        this.setState({ openTab: 1,
                         });
                      }}
                      data-toggle="tab"
                      href="#link1"
                      role="tablist"
                    >
                      International
                    </a>
                  </li>
                  <li className="listDesign">
                    <a
                      className={"alist " + (openTab === 2 ? "aTab" : "aDif")}

                      // className={"alist" + (openTab === 2 ? "aTab" : "aDif")}
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleTabClick(1);
                        this.setState({ openTab: 2 });                      
                      }}
                      data-toggle="tab"
                      href="#link2"
                      role="tablist"
                    >
                      Domestic
                    </a>
                  </li>
                </ul>
                <div className="dropdownDes">
                  <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropdown}>
                    <DropdownToggle caret 
                    style={{fontWeight:"bold"}}
                    >{selectedValue || 'This Week'}</DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => this.handlefilterClick(0)}
                      >
                        This Week
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => this.handlefilterClick(1)}
                      >
                        This Month
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => this.handlefilterClick(2)}
                      >
                        Last Month
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => this.handlefilterClick(3)}
                      >
                        This Year
                      </DropdownItem>
                    </DropdownMenu>
                    {/* {selectedValue && (
                      <div>Selected Value: {selectedValue}</div>
                    )} */}
                  </Dropdown>
                </div>
              </div>

              {/* Overview first 4 cards */}
              <Row style={{ marginBottom: "30px" }}>
                <Col md="6" lg="3">
                  <OverviewCard
                    label={`Total Number of Flights`}
                    amount={appHelpers.numberWithCommasOnly(totalFlights)}
                    // currency="naira"
                    borderColor="#054BA1"
                    visible={overviewSpiner}
                  />
                </Col>
                <Col md="6" lg="3">
                  <OverviewCard
                    label={`Total Number of Passengers`}
                    amount={appHelpers.numberWithCommasOnly(totalPassengers)}
                    // currency="naira"
                    borderColor="#054BA1"
                    visible={overviewSpiner}
                  />
                </Col>
                <Col md="6" lg="3">
                  <OverviewCard
                    label={` GMV (Naira)`}
                    // amount={gmvNaira}
                    amount={appHelpers.numberWithCommasOnly(gmvNaira)}
                    borderColor="#054BA1"
                    visible={overviewSpiner}
                    showNaira
                  />
                </Col>
                <Col md="6" lg="3">
                  <OverviewCard
                    label={`GMV (Dollar)`}
                    amount={appHelpers.numberWithCommasOnly(gmvDollar)}
                    borderColor="#054BA1"
                    visible={overviewSpiner}
                    showDollar
                  />
                </Col>
              </Row>

              {/* First row of bar chat */}
              <Row style={{ marginBottom: "30px" }}>
                <Col md="6" lg="6">
                    {topCarrier && 
                  <BarChart title={"Top 5 Carrier Airlines"}
                  barCharData={topCarrier}

                  />}
                </Col>
                <Col md="6" lg="6">
                {topDestination &&
                  <BarChart title={"Top 5 Destinations"}
                  barCharData={topDestination}
                  />}
                </Col>
              </Row>

              <Row>
                <Col md="6" lg="6" id="chart">
                  <PieChart
                    title={"Top 5 Airlines Generating Revenue"}
                    // pieChatData={pieChatData }
                    // visible={pieChartSpinner}
                    pieChatData={pieChatData}
                  />
                </Col>
                <Col md="6" lg="6">
                    {topOrigin &&
                  <BarChart title={"Top 5 Origin"}
                  barCharData={topOrigin}
                  />}
                </Col>
              </Row>

              <Row style={{ marginTop: "30px" }}>
                <Col md="12" lg="12">
                    {areaChartData &&
                  <AreaChart
                    title={"Top 5 Airlines with the Most Flights"}
                    // visible={areaChartSpinner}
                    areaChartData={areaChartData}
                  />}
                </Col>
              </Row>

              {/*Display loader when component content is dependent on Data from API*/}
              {!contentError && pageRequesting && <PageLoading />}

              {/*Display error when component fail to get Data from API*/}
              {contentError && <PageError error={this.state.contentError} />}

              {/*Display component content when Data is gotten from API*/}
            </CardBody>
            {/* <NotificationSystem ref="notificationSystem" /> */}
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert, airlinesCarriers, entities, dashboard } = state;
  return {
    loggingIn,
    airlinesCarriers,
    requesting,
    pageRequesting,
    modal,
    alert,
    entities,
    dashboard,
  };
}
export default connect(mapStateToProps)(AvicollectDashboard);



// WEBPACK FOOTER //
// ./src/views/avicollectDashboard/view-content.js